import { useState } from 'react'
import background from '../assets/images/blue.png';
import dots from '../assets/images/dots.png'
import { IoEyeOutline } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userlogin } from '../Redux/Action/AuthAction';
import { PiEyeSlash } from "react-icons/pi";
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import useTitle from '../Hooks/useTitle';

const SignIn = () => {
    useTitle('Sign In');
    const { t } = useTranslation('login');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showpassword, setpassword] = useState(false);
    const { loading } = useSelector((state) => state.Auth);
    const [input, setinput] = useState({
        email: "",
        password: "",
    });

    const handlesubmit = (e) => {
        e.preventDefault();
        if (!input.email || !input.password) {
            toast.error(t("error_msg"));
            return;
        }
        dispatch(userlogin(input.email, input.password));
        navigate("/");
    };

    const handlepassword = () => {
        setpassword(!showpassword);
    };

    return (
        <div className="flex flex-col lg:flex-row w-[100vw] min-h-screen">
            {/* Left Sidebar (hidden on small screens) */}
            <div className="hidden lg:block w-[35vw] xl:w-[30vw] relative">
                <img src={background} alt="background" className="h-full w-full object-cover" />
                <div className="absolute top-10 right-[10%]">
                    <img src={dots} alt="dots" />
                </div>

                <div className="absolute top-[28%] text-center grid gap-5 w-full xl:p-[50px] md:p-[30px]">
                    <div>
                        <h1 className="font-semibold text-[40px] xl:text-[48px] text-white">{t("main_title")}</h1>
                        <div className="bg-white rounded-md w-[50px] h-[3px] mx-auto mt-2"></div>
                    </div>
                    <div className="grid gap-2">
                        <p className="text-white font-semibold text-lg break-words">{t("main_subtitle")}</p>
                        <p className="text-white font-light text-sm break-words">{t("description")}</p>
                    </div>
                    <Link to="/reg" className="text-[#3686ff] bg-white max-w-32 w-full h-[52px] rounded-[15px] mx-auto flex items-center justify-center">
                        {t("signup_button")}
                    </Link>
                </div>

                <div className="absolute bottom-10 left-[10%]">
                    <img src={dots} alt="dots" />
                </div>
            </div>

            {/* Right Form Section */}
            {
                loading ? (
                    <div className="w-full h-screen flex justify-center items-center">
                        <CircularProgress size="3rem" />
                    </div>
                ) : (
                    <div className="flex-1 flex justify-center items-center bg-[#EDF4FF] px-4 sm:px-6 py-10">
                        <div className="w-full max-w-[500px]">
                            <form onSubmit={handlesubmit} className="bg-white rounded-[20px] p-6 sm:p-8 flex flex-col gap-8 w-full shadow-md">
                                <div className="text-center">
                                    <h1 className="font-bold text-[#131415] text-[21px] sm:text-[26px]">{t("title")}</h1>
                                    <p className="text-[#535861] text-sm sm:text-base">{t("subtitle")}</p>
                                </div>

                                {/* Inputs */}
                                <div className="flex flex-col gap-4">
                                    {/* Email Input */}
                                    <div className="flex flex-col gap-2">
                                        <label className="text-sm font-medium text-[#131415] text-left">
                                            {t("email_label")}
                                        </label>
                                        <input
                                            type="text"
                                            name="email"
                                            placeholder={t("email_placeholder")}
                                            value={input.email}
                                            onChange={(e) => setinput({ ...input, [e.target.name]: e.target.value })}
                                            className="border border-[#c3cbd7] py-2 px-3 rounded-lg text-sm w-full"
                                        />
                                    </div>

                                    {/* Password Input */}
                                    <div className="flex flex-col gap-2 relative">
                                        <label className="text-sm font-medium text-[#131415] text-left">
                                            {t("password_label")}
                                        </label>
                                        <input
                                            type={showpassword ? "text" : "password"}
                                            name="password"
                                            placeholder={t("password_placeholder")}
                                            value={input.password}
                                            onChange={(e) => setinput({ ...input, [e.target.name]: e.target.value })}
                                            className="border border-[#c3cbd7] py-2 px-3 rounded-lg text-sm w-full"
                                        />
                                        <div
                                            className="absolute top-9 right-3 text-black cursor-pointer sm:block hidden"
                                            onClick={handlepassword}
                                        >
                                            {showpassword ? <IoEyeOutline /> : <PiEyeSlash />}
                                        </div>
                                    </div>
                                </div>

                                {/* Forgot Password */}
                                <div className="text-right -mt-4">
                                    <Link to="/forgot-password" className="text-[#3686ff] text-sm hover:underline">
                                        {t("forgot_password")}
                                    </Link>
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    className="bg-[#3686ff] text-white w-full h-[52px] rounded-[15px] flex items-center justify-center font-medium"
                                >
                                    {loading ? t("signing_in") : t("sign_in_button")}
                                </button>
                            </form>

                            {/* Mobile Sign Up Link */}
                            <p className="text-center text-sm text-[#535861] mt-4 lg:hidden">
                                {t("no_account")}{" "}
                                <Link to="/reg" className="text-[#3686ff] font-medium">{t("signup_button")}</Link>
                            </p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default SignIn;
